
import React from 'react';
import PropTypes from 'prop-types';

const IngredientsIcon = ({ className }) => {
  return (
    <svg 
      width="27" 
      height="20" 
      viewBox="0 0 27 20" 
      fill="none" 
      className={`fill-current ${className}`}
      xmlns="http://www.w3.org/2000/svg">
      <path d="M23.4448 17.5835C23.4805 16.3054 23.4448 13.5194 22.4483 11.1641C21.9502 9.98658 21.2048 8.92984 20.2627 8.06543" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="transparent"/>
      <path d="M3.61133 17.5832C3.61133 12.0707 5.94466 5.37423 13.263 5.35259C14.5783 5.3487 15.8832 5.58594 17.113 6.05258" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="transparent"/>
      <path d="M0.75 18.3896H25.775" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="transparent"/>
      <path d="M20.6125 6.83984L20.2625 8.06487L20.0875 8.85239C19.6457 10.6765 18.7067 12.3424 17.375 13.6649L17.025 13.9274C16.8035 14.1716 16.5334 14.3667 16.232 14.5002C15.9306 14.6337 15.6046 14.7028 15.275 14.7028C14.9453 14.7028 14.6193 14.6337 14.3179 14.5002C14.0165 14.3667 13.7465 14.1716 13.525 13.9274L12.825 13.2274L12.125 12.5273C11.8922 12.2992 11.7072 12.027 11.5809 11.7265C11.4547 11.426 11.3896 11.1033 11.3896 10.7773C11.3896 10.4514 11.4547 10.1288 11.5809 9.82827C11.7072 9.52778 11.8922 9.25546 12.125 9.02734L12.475 8.76485C13.732 7.43884 15.3405 6.49804 17.1125 6.05238H17.2L19.2125 5.52734L20.6125 6.83984Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="transparent"/>
      <path d="M24.4627 6.14023C24.1315 6.39528 23.7405 6.56133 23.327 6.62259C22.9135 6.68385 22.4912 6.63831 22.1002 6.49025L20.5252 6.84022L19.3877 5.61525L19.7377 4.04026C19.5566 3.67634 19.4849 3.26762 19.5315 2.86379C19.5781 2.45996 19.741 2.07834 20.0002 1.76523C20.8752 0.890231 22.6252 1.15274 23.8502 2.37774C25.0752 3.60274 25.3377 5.26523 24.4627 6.14023Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="transparent"/>
    </svg>
  );
};

IngredientsIcon.propTypes = {
  className: PropTypes.string, // Optional: allows passing Tailwind or custom classes
};

IngredientsIcon.defaultProps = {
  className: '', // Default to an empty string
};

export default IngredientsIcon;